import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["dialog", "header", "description"]

  connect() {
    this.defaultHeader = this.headerTarget.innerText
    Turbo.config.forms.confirm = (message, element) => {
      this.headerTarget.innerText = element?.dataset?.header || this.defaultHeader
      this.descriptionTarget.innerText = message
      this.dialogTarget.showModal()
      return new Promise((resolve) => {
        this.dialogTarget.addEventListener("close", () => {
          resolve(this.dialogTarget.returnValue === "confirm")
        }, { once: true })
      })
    }
  }
}
